<template>
  <div class="stripe-operation">
    <a-button :loading="loading" size="large" type="primary" @click="handlePayClick">
      {{ displayName }}
    </a-button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  url?: string;
  loading: boolean;
}>();

const { $t } = useNuxtApp();

const displayName = computed(() => {
  if (props.loading) {
    return $t('chuang-jian-zhong');
  }

  return $t('qu-zhi-fu');
});

const handlePayClick = () => {
  if (props.loading || !props.url) {
    return;
  }
  location.href = props.url;
};
</script>

<style lang="scss" scoped>
.stripe-operation {
  display: block;
  margin: 50px auto 30px;
  > button {
    display: inline-block;
    min-width: 100px;
    margin: 0 8px;
  }
}
</style>
